import { isObject } from "@/shared/libs/type-utils";
import { Fragment, type ReactNode, type JSX, type HTMLAttributes } from "react";
import { nanoid } from "nanoid";

type ItemWithId<X> = X & { id?: string | number; keyBy?: string | number };
type Item<X> = X extends object ? ItemWithId<X> : X;

interface ListProps<X> {
  items: Item<X>[];
  renderItems: (item: Item<X>, index: number) => ReactNode;
  Wrapper?: JSX.ElementType;
  props?: HTMLAttributes<HTMLElement>;
}

export default function List<X>({
  items,
  renderItems,
  Wrapper,
  props,
}: ListProps<X>) {
  const RENDERED_ITEMS = items.map((item, index) => (
    <Fragment
      key={
        isObject(item) && item !== null
          ? "keyBy" in item && item.keyBy !== undefined
            ? (item.keyBy as string | number)
            : "id" in item && item.id !== undefined
            ? (item.id as string | number)
            : nanoid()
          : nanoid()
      }
    >
      {renderItems(item, index)}
    </Fragment>
  ));

  return Wrapper ? (
    <Wrapper {...props}>{RENDERED_ITEMS}</Wrapper>
  ) : (
    RENDERED_ITEMS
  );
}
